import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";

import DetailForm from "./DetailForm";
import AfgelopenPage from "../afgelopen/AfgelopenPage";
import AutoBindComponent from "../../common/AutoBindComponent";
import DetailPageHelper from "./DetailPageHelper";
import * as layoutActions from "../../../actions/zoekmotorLayoutActions";
import { throwException } from "../../../actions/exceptionActions";

class DetailPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            errors: null,
            isAfgelopen: false
        };

        this.pageHelper = new DetailPageHelper(this, null);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.robotsMeta = document.createElement("meta");
        this.robotsMeta.name = "robots";
        this.robotsMeta.content = "noindex";
        document.head.appendChild(this.robotsMeta);
        this.pageHelper.init();
    };

    componentWillUnmount = () => {
        super.componentWillUnmount();
        document.head.removeChild(this.robotsMeta);
    };

    isReadyToRender = () => {
        return this.state.model;
    };

    render() {
        if (this.state.isAfgelopen)
            return <AfgelopenPage />;

        if (!this.isReadyToRender())
            return null;

        const model = this.state.model;

        return (
            <DetailForm
                model={model}
                gemeenten={this.props.gemeenten}
                postcodes={this.props.postcodes}
                landen={this.props.landen}
            />);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        gemeenten: state.referentie.gemeenten,
        postcodes: state.referentie.postcodes,
        landen: state.referentie.landen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        loadDetailLayout: bindActionCreators(layoutActions.loadDetailPageLayout, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailPage);